import { markerDisplayName } from 'pages/marking/helpers/presentation.helpers';
import type { BaseCustomerUser } from 'services/assist-api/entities/customer-user/types';
import type { TestInstanceResponseMarkerWithCustomerUser } from 'services/assist-api/entities/test-instance-response-marker/types';
import type { MarkItemFormValue } from './mark-response-form.schema';

/** Returns the organisation user linked to the marker of the saved mark item. */
export function markItemMarkerOrganisationUser(
  markers: TestInstanceResponseMarkerWithCustomerUser[],
  organisationUsers: BaseCustomerUser[],
  savedMarkItem?: MarkItemFormValue
): BaseCustomerUser | undefined {
  const markItemMarker = markers.find((marker) => marker.id === savedMarkItem?.activeMarkerId);
  return organisationUsers.find((ou) => ou.id === markItemMarker?.user.id);
}

/**
 * Details of the marker of the mark item or if the mark item has been scored. Only marking admins
 * and above should be able to see the names of other markers.
 */
export function rubricItemTooltip(
  canAdministrateMark: boolean,
  markerOrganisationUser: BaseCustomerUser | undefined,
  activeMarkerId: number,
  savedMarkItem?: MarkItemFormValue
): string {
  if (!savedMarkItem?.id) return 'Score not saved yet.';
  if (canAdministrateMark)
    return `Marker: ${markerOrganisationUser ? markerDisplayName(markerOrganisationUser) : 'Not found.'}`;
  return `${savedMarkItem.activeMarkerId === activeMarkerId ? 'You marked' : "You didn't mark"} this mark item.`;
}
